import { render, staticRenderFns } from "./Tooth.vue?vue&type=template&id=b3d485ec&scoped=true"
import script from "./Tooth.vue?vue&type=script&lang=js"
export * from "./Tooth.vue?vue&type=script&lang=js"
import style0 from "./Tooth.vue?vue&type=style&index=0&id=b3d485ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d485ec",
  null
  
)

export default component.exports